import { getHostKey } from './checkHost'

export const getKeycloakConfig = () => {
  if (getHostKey() === 'test' || process.env.REACT_APP_STAND === 'test') {
    return {
      realm: 'test_users_realm',
      clientId: 'test-users',
    }
  }

  if (getHostKey() === 'dev2' || process.env.REACT_APP_STAND === 'dev2') {
    return {
      realm: 'idpay_realm',
      clientId: 'oauth2-proxy',
    }
  }

  return {
    realm: 'idpay_realm',
    clientId: 'oauth2-proxy',
  }
}
